
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Divider, Typography, InputBase, IconButton, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AlertDialog from '../components/AlertDialog';
import Loading from '../components/Loading';
import Projects from '../components/Projects';

const Home = () => {
    const [searchText, setSearchText] = useState('');
    const [result, setResult] = useState([]);
    const [dataAlert, setDataAlert] = useState({ isShow: false, severity: '', title: '', message: '' });
    const [showLoading, setShowLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [isSearched, setIsSearched] = useState(false);

    useEffect(() => {
        getProjects();
    }, []);

    const getProjects = () => {
        axios.get(`https://backend-minerva-entity.pathrover.ir/api/project/GetProjects`).then(res => {
            setProjects(res.data);
        });
    }

    const search = (ev) => {
        if (searchText === '') {
            setDataAlert({ isShow: true, severity: 'error', title: 'Error', message: 'Enter MINERVA protein here...' });
            setIsSearched(false);
        }
        else {
            setIsSearched(true);
            setShowLoading(true);
            axios.get(`https://backend-minerva-entity.pathrover.ir/api/project/FindElement/${searchText}`).then(res => {
                setResult(res.data);
                setShowLoading(false);
            });
        }
    }
    return (
        <>
            <Typography variant="h3" gutterBottom align='center'>
                MINERVA ENTITY EXPLORER
            </Typography>
            <Typography variant="h6" gutterBottom align='center'>
                Knowing in which disease map the desired entity exists.
            </Typography>
            <Divider />
            <Paper
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', mt: '20px' }}>
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search Your Entity"
                    autoFocus
                    fullWidth
                    inputProps={{ 'aria-label': 'search-box' }}
                    value={searchText}
                    onChange={(ev) => {
                        if (ev.target.value === '')
                            setIsSearched(false);
                        setSearchText(ev.target.value)
                    }}
                    onKeyDown={(ev) => {
                        if (ev.key === 'Enter') {
                            search();
                        }
                    }}
                />
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={search}>
                    <SearchIcon />
                </IconButton>
            </Paper>

            {!isSearched &&
                <>
                    <Typography variant="subtitle2" align='left' sx={{ mt: '30px', color: 'red', fontWeight: 'bold' }}>
                        The search is done in the following databases.
                    </Typography>
                    <Projects projects={projects} isAdmin={false} />
                </>
            }
            {isSearched &&
                <TableContainer component={Paper} sx={{ maxHeight: 500, mt: '30px' }}>
                    <Table stickyHeader sx={{ maxHeight: 440, minWidth: 650 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Id</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Site</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Site map</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {result.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell scope="row">
                                        {row.elementId}
                                    </TableCell>
                                    <TableCell align="left">{row.site}</TableCell>
                                    <TableCell align="left">{row.siteMap}</TableCell>
                                    <TableCell align="left">{row.type}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            <AlertDialog data={dataAlert} onClose={e => setDataAlert({ isShow: false })} />
            <Loading isShow={showLoading} />
        </>
    )
};

export default Home;